import { ofType } from "redux-observable";
import { guard } from "../../guards/guard";
import { TypeActionTrade } from "../actionTrade";
import { checkHasEnoughResourceForTrade } from "../checks/checkHasEnoughResourceForTrade";
import { pathBuyProduct } from "../paths/pathBuyProduct";
import { pathBuyProductNotEnoughResource } from "../paths/pathBuyProductNotEnoughResource";
export var epicBuyProduct = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTrade.Buy), guard(state$, deps, pathBuyProduct)([
        checkHasEnoughResourceForTrade(pathBuyProductNotEnoughResource),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/epics/epicBuyProduct.ts
// module id = 2449
// module chunks = 3